export default __webpack_public_path__ + "static/media/i5.a1556a17.png";